// IE 2026 09 17 / ODOO-… (замечание Игоря): «выделив Грузию в верхнем виджете, ожидал, что в нижнем
// виджете тоже подсветится Грузия» — подсветка ячеек с таким же текстом общая для виджетов страницы.
//
// CSS.highlights — ОДИН реестр на приложение: если каждый грид кладёт свой Highlight под именем
// cell-match, последний затирает остальные. Поэтому диапазоны собираются здесь по ключу грида,
// а Highlight пересобирается один на всех. Плюс шина текста: грид, в котором выбрали ячейку,
// публикует её текст, остальные гриды ТОЙ ЖЕ страницы подсвечивают его у себя.
const RANGES = new Map()
const SUBS = new Set()
const MAX = 2000            // страховка: диапазонов на всю страницу

// IE 2026 09 18 (заказ Игоря): грид с выбранной ячейкой подсвечивает и ЕЁ текст, если совпадения есть где-то ещё —
// для этого он должен знать, сколько совпадений нашли ДРУГИЕ гриды: счётчик «чужих» диапазонов + оповещение о смене
const CHANGE_SUBS = new Set()
const SELF = new Map()      // key → сколько диапазонов грида приходится на саму выбранную ячейку (в «совпадения» не идут)

export function cellMatch_others(key) {
    let n = 0
    for (const [k, rs] of RANGES) if (k !== key) n += Math.max(0, rs.length - (SELF.get(k) || 0))
    return n
}
export function cellMatch_onChange(fn) { CHANGE_SUBS.add(fn); return () => CHANGE_SUBS.delete(fn) }

export function cellMatch_ranges(key, ranges, selfCount = 0) {
    const before = (RANGES.get(key) || []).length - (SELF.get(key) || 0)
    if (ranges && ranges.length) { RANGES.set(key, ranges); SELF.set(key, selfCount || 0) }
    else { RANGES.delete(key); SELF.delete(key) }
    const after = (RANGES.get(key) || []).length - (SELF.get(key) || 0)
    if (before !== after) for (const fn of [...CHANGE_SUBS]) { try { fn(key) } catch (e) { /* подписчик уже размонтирован */ } }
    const CSSH = window.CSS && window.CSS.highlights
    if (!CSSH || typeof window.Highlight !== 'function') return
    const all = []
    for (const rs of RANGES.values()) {
        for (const r of rs) { all.push(r); if (all.length >= MAX) break }
        if (all.length >= MAX) break
    }
    if (!all.length) CSSH.delete('cell-match')
    else CSSH.set('cell-match', new window.Highlight(...all))
}

// IE 2026 09 18 / ODOO-… (замечание Игоря): тексты, подсвеченные внутри элемента, — «продолжение» обрезанной ячейки
// (clipOverlay) повторяет подсветку у себя: диапазоны Highlight привязаны к исходному DOM, на копию не переходят
export function cellMatch_textsIn(el) {
    const out = []
    if (!el) return out
    for (const rs of RANGES.values()) {
        for (const r of rs) {
            try { if (el.contains(r.startContainer)) { const t = r.toString(); if (t && !out.includes(t)) out.push(t) } } catch (e) { /* диапазон отвалился */ }
        }
    }
    return out
}

export function cellMatch_subscribe(fn) { SUBS.add(fn); return () => SUBS.delete(fn) }

export function cellMatch_publish(text, srcKey, page) {
    for (const fn of [...SUBS]) { try { fn(text || '', srcKey, page) } catch (e) { /* подписчик уже размонтирован */ } }
}

let SEQ = 0
export function cellMatch_key() { return 'grid-' + (++SEQ) }

// IE 2026 09 20 / ODOO-5828 (замечание Игоря: «при входе в ячейку вижу выделения нулей — в ячейках, в которых они были скрыты как пустые
// значения»): текст, которого пользователь НЕ видит, подсветки не красят. ::highlight() рисует фон и подчёркивание и под прозрачным
// текстом — спрятанный ноль (класс ячейки cell-zero: color: transparent) проявлялся рамкой. Признак: ячейка грида cell-zero либо
// вычисленный цвет текста с нулевой альфой. memo — WeakMap на один проход (getComputedStyle на элемент — один раз).
// Общий выключатель подсветок — настройка fe.ux.highlightSkipHidden (проверяет вызывающий)
// IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок): классы ячеек, чей текст спрятан оформлением, — cell-zero (спрятанный ноль),
// gt-dup-hover / gt-dup-arrow (повтор итога раскрытой группы: текст прозрачен до наведения на строку). Дешёвая проверка по классам —
// для циклов по всем ячейкам грида (getComputedStyle не зовётся)
export const HIDDEN_TEXT_CLASSES = ['cell-zero', 'gt-dup-hover', 'gt-dup-arrow']
export function cellMatch_hiddenClass(el) {
    const cell = el && el.nodeType === 1 ? el.closest('.wj-cell') : null
    if (!cell) return false
    for (const c of HIDDEN_TEXT_CLASSES) if (cell.classList.contains(c)) return true
    return false
}
export function cellMatch_hiddenText(el, memo) {
    if (!el || el.nodeType !== 1) return false
    if (memo && memo.has(el)) return memo.get(el)
    let hidden = false
    try {
        if (cellMatch_hiddenClass(el)) hidden = true   // IE 2026 09 23 / ODOO-…: спрятанный ноль / повтор итога группы — по классам
        else {
            const cs = getComputedStyle(el)
            const isNone = (c) => c === 'transparent' || /^rgba\(\d+,\d+,\d+,0(\.0+)?\)$/.test(c) || /^rgb\([^)]*\/0(\.0+)?%?\)$/.test(c)
            hidden = isNone(String(cs.color || '').replace(/\s+/g, ''))
                || isNone(String(cs.webkitTextFillColor || '').replace(/\s+/g, ''))   // текст, спрятанный через -webkit-text-fill-color
        }
    } catch (e) { hidden = false }
    if (memo) memo.set(el, hidden)
    return hidden
}
// текст «нулевого» значения, как его рисует грид и как он стоит в редакторе ячейки: 0 / 0,0 / 0.00 / -0
export function cellMatch_zeroText(t) { return /^[-+]?0+([.,]0+)?$/.test(String(t ?? '').trim()) }
